document.addEventListener('DOMContentLoaded', ()=>{
    const collapsibleTab = (target)=>{
        target.target.closest('[js-collapsible-outer]').classList.toggle('active');
        if ( target.target.closest('[js-collapsible-outer]').classList.contains('active') ){
        let HeightElementData = target.target.closest('[js-collapsible-outer]').querySelector('[js-collapsible-content]');
        target.target.closest('[js-collapsible-outer]').querySelector('[js-collapsible-content]').style.maxHeight = `${HeightElementData.scrollHeight}px`;
        }else{
        target.target.closest('[js-collapsible-outer]').querySelector('[js-collapsible-content]').style.maxHeight = null;
        }              
    }    

    if( document?.querySelectorAll('.swiper.slider-section__wrapper.Thumbnail')?.length ){
        let MediaThumbnailView = new Swiper('.swiper.slider-section__wrapper.Thumbnail', {
            slidesPerView: 4,
            direction: 'vertical',
            spaceBetween: 12,
            loop: false,
            navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'},
            watchSlidesProgress: true,
            slideHeight: 200,
            on: {
                init: (swiper) => {
                    if ( (document.querySelector('.slider-section__wrapper.Thumbnail').querySelector('.swiper-wrapper').childElementCount > 4) && (window.screen.width > 749) ){
                        let totalGap = swiper.slides[0].clientHeight * swiper.passedParams.slidesPerView;
                        totalGap = parseInt(totalGap - 36);
                        document.querySelector('.swiper.slider-section__wrapper.Thumbnail').style.height = totalGap+'px';
                        window.addEventListener('resize', ()=>{
                            if( window.screen.width > 749 ){
                                let totalGap = swiper.slides[0].clientHeight * swiper.passedParams.slidesPerView;totalGap = parseInt(totalGap - 36);
                                document.querySelector('.swiper.slider-section__wrapper.Thumbnail').style.height = totalGap+'px'; 
                            }
                        });
                    }else if( window.screen.width > 749 ){
                        let totalGap = swiper.slides[0].clientHeight * swiper.passedParams.slidesPerView;
                        totalGap = parseInt(totalGap - 56);
                        document.querySelector('.swiper.slider-section__wrapper.Thumbnail').style.height = totalGap+'px';
                        window.addEventListener('resize', ()=>{
                            if( window.screen.width > 749 ){
                                let totalGap = swiper.slides[0].clientHeight * swiper.passedParams.slidesPerView;totalGap = parseInt(totalGap - 56);
                                document.querySelector('.swiper.slider-section__wrapper.Thumbnail').style.height = totalGap+'px'; 
                            }
                        });              
                    }
                }
            }     
        });

        let MainProductGallery = new Swiper('.swiper.slider-section__wrapper.MainImage',{
            autoHeight:true,
            centeredSlides: false,
            loop: false,
            slidesPerView: 1,
            spaceBetween: 15,
            watchOverflow: true,
            navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
            scrollbar: {el: ".swiper-scrollbar",draggable: true},
            thumbs: {swiper: MediaThumbnailView}
        });
    }

    if( document?.querySelectorAll('.marquee_interior.swiper-container')?.length ){
        new Swiper('.marquee_interior.swiper-container',{
            spaceBetween:0,
            centeredSlides:!0,
            speed:6000,
            autoplay:{delay:1},
            loop:!0,
            slidesPerView:'auto',
            allowTouchMove:!1,
            disableOnInteraction:!0
        });
    }      
   
    if (document?.querySelectorAll('.productTestimonial__testimonials.swiper')?.length) {
        new Swiper('.productTestimonial__testimonials.swiper', {
            loop: true,
            speed: 600,
            grabCursor: true,
            pagination: { el: ".swiper-pagination", clickable: true },
            navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
            breakpoints: {
                0: { slidesPerView: 'auto', spaceBetween: 10, centeredSlides: true, loopedSlides: 3, loopAdditionalSlides: 3 },
                768: { slidesPerView: 4.5, spaceBetween: 15, centeredSlides: true, centerInsufficientSlides: true }
            }
        });
    }

    class PurchaseSelection extends HTMLElement {
        constructor() {
            super();
            this.attachEvents();
        }
        attachEvents() {
            this.querySelectorAll(`.productMain__item_selection`).forEach((elm)=>{
                elm.querySelector(`[name="quantity_item"]`).addEventListener('change', () => {
                    this.syncVariants();
                });
            });
            // this.defaultSelected = this.querySelector('.productMain__options_interior').firstChild.querySelector('input');
            // this.defaultSelected.click();
            // this.defaultSelectedClick = new Event('click', { bubbles: true, cancelable: true });
            // this.defaultSelected.dispatchEvent(this.defaultSelectedClick);  
            
            const url = new URL(window.location.href);
const variantId = url.searchParams.get('variant');

if (variantId) {
  // 👉 Find variant from JSON
  const variant = this.getVariantData().find(v => v.id == variantId);

  if (variant) {
    // 👉 Select matching inputs based on variant options
    variant.options.forEach((opt, index) => {
      const inputs = this.querySelectorAll('input[name="quantity_item"]');
      
      inputs.forEach(input => {
        if (input.value === opt) {
          input.checked = true;
        }
      });
    });

    // 👉 Sync everything after setting
    this.syncVariants();
    return; // 🚫 STOP default selection
  }
}

// 👉 Fallback (only if NO variant in URL)
this.defaultSelected = this.querySelector('.productMain__options_interior').firstChild.querySelector('input');
this.defaultSelected.click();
this.defaultSelected.dispatchEvent(new Event('click', { bubbles: true }));
        }
        syncVariants() {
            this.selectedValue();
            this.selectMasterVariant(this.choosedOneTime);
            this.UpdateAppearance();
        }
        selectedValue() {
            this.choosedOneTime = [...this.querySelectorAll('input[name="quantity_item"]:checked')].map(input => input.value);
        }
        getVariantData() {
            return this.variantData ||= JSON.parse(this.querySelector('[type="application/json"]').textContent);
        }
        selectMasterVariant(choices) {
            this.currentVariant = this.getVariantData().find(variant =>
            !variant.options.some((opt, idx) => opt !== choices[idx])
            );
        }
        UpdateAppearance() {
            this.submitBtns = document.querySelectorAll(`.mainProduct__addbutton.product-form__submit[type="submit"]`);
            this.submitBtnsOthers = document.querySelectorAll(`.productFeedback__quickadd .product-form__submit[type="submit"]`);
            if (!this.currentVariant) return;
            this.isAvailable = this.currentVariant.available;
            this.soldOut = !this.isAvailable;
            [...this.submitBtns].forEach(btn => {
                this.label = btn.querySelector('span');
                if( this.soldOut == true ){
                   this.label.innerHTML = window.variantStrings.soldOut;
                }else{
                   this.label.innerHTML = window.variantStrings.addToCart;
                }
                btn.disabled = this.soldOut;
            });
            [...this.submitBtnsOthers].forEach(btnOth => {
                this.labelOth = btnOth.querySelector('span');
                if( this.soldOut == true ){
                   this.labelOth.innerHTML = window.variantStrings.soldOut;
                }else{
                   this.labelOth.innerHTML = window.variantStrings.addToCart;
                }
                btnOth.disabled = this.soldOut;
            });            
            this.closest('.product__info-container').querySelector('.productMain__buybuttons_main').querySelector('[name="id"]').value = this.currentVariant.id;
            document.querySelectorAll(`.productFeedback__quickadd`).forEach((oel)=>{ oel.querySelector(`[name="id"]`).value = this.currentVariant.id });
            this.productHandle = document.querySelector('.mainProduct__layoutwp')?.dataset.url;
            if (this.productHandle) {
                window.history.replaceState(null, '', `${this.productHandle}?variant=${this.currentVariant.id}`);
            }

//             this.productHandle = document.querySelector('.mainProduct__layoutwp')?.dataset.url;

// if (this.productHandle && this.currentVariant?.id) {
//   const url = new URL(window.location.href);
//   const existingVariant = url.searchParams.get('variant');

//   // 👉 1. Page load behavior
//   if (!this.variantInitialized) {
//     this.variantInitialized = true;

//     // If NO variant in URL → add it
//     if (!existingVariant) {
//       window.history.replaceState(null, '', `${this.productHandle}?variant=${this.currentVariant.id}`);
//     }

//     // If variant already in URL → DO NOTHING (respect it)
//     return;
//   }

//   // 👉 2. Variant change (always update)
//   window.history.replaceState(null, '', `${this.productHandle}?variant=${this.currentVariant.id}`);
// }
        }
    }
    customElements.define('custom-variants-selection', PurchaseSelection);

    if( document?.querySelectorAll('.perfectFor_tabs_names .perfectFor_tab_name')?.length ){
        document.querySelectorAll('.perfectFor_tabs_names .perfectFor_tab_name').forEach((elm)=>{
            elm.addEventListener('click', (target)=>{
                target.preventDefault();
                let targetTab = target.currentTarget.dataset.tab;
                document.querySelectorAll('.perfectFor_tabs_names .perfectFor_tab_name').forEach((elm)=>{ elm.classList.remove('active') });
                document.querySelectorAll('.perfectFor_tabs_details .perfectFor_tab_detail').forEach((elm)=>{ elm.classList.remove('active') });
                target.currentTarget.classList.add('active');
                document.querySelector(`[data-tab-content="${targetTab}"]`).classList.add('active');
            });
        });
    }

    if( document?.querySelectorAll('.productFeedback__interior .productSeeaction__playIcon')?.length ){
        document.querySelectorAll('.productFeedback__interior .productSeeaction__playIcon').forEach((elm)=>{
            elm.addEventListener('click', (target)=>{
                target.preventDefault();
                let videoElement = target.target.closest('.productFeedback__interior').querySelector('video');
                if (videoElement.paused) { 
                    target.target.closest('.productFeedback__interior').classList.add('playing');
                    videoElement.play(); 
                }else{
                    target.target.closest('.productFeedback__interior').classList.remove('playing');
                     videoElement.pause();
                }
            });     
        }); 
    }

    if( document?.querySelectorAll('.productSeeaction__visibility_int .productSeeaction__playIcon')?.length ){
        document.querySelectorAll('.productSeeaction__visibility_int .productSeeaction__playIcon').forEach((elm)=>{
            elm.addEventListener('click', (target)=>{
                target.preventDefault();
                let videoElement = target.target.closest('.productSeeaction__visibility_int').querySelector('video');
                if (videoElement.paused) {
                    target.target.closest('.productSeeaction__visibility_int').classList.add('playing'); 
                    videoElement.play();
                }else{
                    target.target.closest('.productSeeaction__visibility_int').classList.remove('playing'); 
                    videoElement.pause();
                }
            });     
        });
    }    

    if( document?.querySelectorAll('[js-collapsible-header]')?.length ){
        document.querySelectorAll('[js-collapsible-header]').forEach((elm)=>{
            elm.addEventListener('click', (target)=>{
                target.preventDefault();
                collapsibleTab(target);
            })
        });  
    }

    if( document?.querySelectorAll('.mainProduct__tabs__lists [data-tab]')?.length ){
        document.querySelectorAll('.mainProduct__tabs__lists [data-tab]').forEach((elm)=>{
            elm.addEventListener('click', (target)=>{
                let targetTabMain = target.currentTarget.dataset.tab;
                document.querySelectorAll('.mainProduct__tabs__lists [data-tab]').forEach((elm)=>{ elm.classList.remove('active') });
                document.querySelectorAll('.mainProduct___tabs_contentMain [data-tab-content]').forEach((elm)=>{ elm.classList.remove('active') });
                target.currentTarget.classList.add('active');
                document.querySelector(`.mainProduct___tabs_contentMain [data-tab-content="${targetTabMain}"]`).classList.add('active');
            });
        });
    }

    if( document?.querySelectorAll('.productIngredients__fulllist')?.length ){
        document.querySelector('.productIngredients__fulllist').addEventListener('click',(target)=>{
            target.preventDefault();
            target.target.closest('.productIngredients__mainwrapper').classList.add('active');
            document.body.classList.add('overflow-hidden');
        });
    }

    if( document?.querySelectorAll('[js-crossed-popup]')?.length ){
        document.querySelectorAll('[js-crossed-popup]').forEach((elm)=>{
            elm.addEventListener('click',(target)=>{
                target.preventDefault();
                target.target.closest('.productIngredients__mainwrapper').classList.remove('active');
                document.body.classList.remove('overflow-hidden');
            }); 
        });
    }   

    if( document?.querySelectorAll('.productBeforeAfter__mg_divider_xt')?.length ){
        const Dragdivider = document.querySelector('.productBeforeAfter__mg_divider_xt');
        const DragWrapperMain = document.querySelector('.productBeforeAfter__mg_divider_loaded');
        const beforeImage = document.querySelector('.after_mg_flip');
        const beforeImageLabel = document.querySelector('.productBeforeAfter__ot_headlines_before');
        const afterImageLabel = document.querySelector('.productBeforeAfter__ot_headlines_after');
        const afterImage = document.querySelector('.before_mg_flip');
        let isDragging = false;
        const centerDividerAndClips = () => {
            const wrapperRect = DragWrapperMain.getBoundingClientRect();
            const dividerWidth = Dragdivider.offsetWidth;
            const centerPos = (wrapperRect.width / 2) - (dividerWidth / 2);
            Dragdivider.style.left = `${centerPos}px`;
            let xmg = centerPos + (dividerWidth / 2);
            afterImage.style.clip = `rect(auto, ${xmg}px, auto, auto)`;
            afterImageLabel.style.clip = `rect(auto, ${xmg}px, auto, auto)`;
            beforeImage.style.clip = `rect(auto, auto, auto, ${xmg}px)`;
            beforeImageLabel.style.clip = `rect(auto, auto, auto, ${xmg}px)`;
        };
        const onDrag = (e) => {
            if (!isDragging) return;
            let clientX = e.clientX;
            if (e.touches && e.touches.length > 0) {
                clientX = e.touches[0].clientX;
            }
            const wrapperRect = DragWrapperMain.getBoundingClientRect();
            let x = clientX - wrapperRect.left;
            const dividerWidth = Dragdivider.offsetWidth;
            if (x < 0) x = 0;
            if (x > (wrapperRect.width - dividerWidth)) x = wrapperRect.width - dividerWidth;
            Dragdivider.style.left = `${x}px`;
            let xmg = x + (dividerWidth / 2);
            afterImage.style.clip = `rect(auto, ${xmg}px, auto, auto)`;
            afterImageLabel.style.clip = `rect(auto, ${xmg}px, auto, auto)`;
            beforeImage.style.clip = `rect(auto, auto, auto, ${xmg}px)`;
            beforeImageLabel.style.clip = `rect(auto, auto, auto, ${xmg}px)`;
        };
        const stopDrag = () => {
            if (!isDragging) return;
            isDragging = false;
            document.removeEventListener('mousemove', onDrag);
            document.removeEventListener('mouseup', stopDrag);
            document.removeEventListener('touchmove', onDrag);
            document.removeEventListener('touchend', stopDrag);
            document.removeEventListener('mouseleave', stopDrag);
        };
        const onStartDrag = (e) => {
            e.preventDefault(); 
            isDragging = true;
            document.addEventListener('mousemove', onDrag);
            document.addEventListener('mouseup', stopDrag);
            document.addEventListener('touchmove', onDrag, { passive: false });
            document.addEventListener('touchend', stopDrag);
            document.addEventListener('mouseleave', stopDrag);
        };
        Dragdivider.addEventListener('mousedown', onStartDrag);
        Dragdivider.addEventListener('touchstart', onStartDrag);
        centerDividerAndClips(); 
        window.addEventListener('resize', centerDividerAndClips);
    }
})